import api from "./AxiosInterceptor";
import EndpointConfig from "./EndpointService";

const referenceTableDataPayload = [
  {
    refTableName: "UI_OPTIONS",
    filterCriteria: {},
    refTableColumns: ["CODE", "DISPLAY_ES", "DISPLAY_EN", "RANK"],
  },
  {
    refTableName: "SEX_DROPDOWN_OPTIONS",
    filterCriteria: {},
    refTableColumns: ["CODE", "DISPLAY_ES", "DISPLAY_EN", "RANK"],
  },
  {
    refTableName: "USER_ROLE",
    filterCriteria: {},
    refTableColumns: ["CODE", "DISPLAY_ES", "DISPLAY_EN", "RANK", "VALUE"],
  },
  {
    refTableName: "PREFERRED_LANGUAGE",
    filterCriteria: {},
    refTableColumns: ["CODE", "DISPLAY_ES", "DISPLAY_EN", "RANK", "VALUE"],
  },
];

export const getReferenceData = async () => {
  const url = EndpointConfig("apiEndpointReferenceTableData");
  const response = await api.post(url, referenceTableDataPayload);
  return response;
};
